// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2Iv7_YVLn8DB","loader":"_20QktSh_cEdf","rotation":"_3dadKfKHtIC3"};